export function getSafeNumber(value: number | string | undefined) {
  const parsedValue = Number(value)
  return Number.isNaN(parsedValue) ? 0 : parsedValue
}
